export default __webpack_public_path__ + "static/media/settings.49d6d275.svg";